import { Injectable, NgZone, HostListener } from '@angular/core';

import * as $ from "jquery";
import { fabric } from 'fabric';
@Injectable({
  providedIn: 'root'
})
export class DrawingToolService {
  public blob_image_url = "/Lasresan/FK/";

 
  public dragging_flag = false;
  public trash_can_visible = false;
  public bin_img: any;
  public selectedObject: any;


  public eraser: any = [];
  public shapes: any = [];
  public colorpicker: any = [];
  public text: any = [];
  public marker: any = {};
  public pencil: any = {};
  public highlighter: any = {};
  public curtainMenu: any = {};
  public menudata: any = [
    {
      name: 'menuhandle',
      sub: null,
      cursor: this.blob_image_url + 'DrawingTool/cursor/crosshair.png',
      left: '7',
      top: '7',
      class: '',
      bg_class: '',
      show: true
    },
    {
      name: 'marker',
      sub: null,
      cursor: this.blob_image_url + 'DrawingTool/cursor/marker.png',
      left: '0',
      top: '12',
      class: '',
      bg_class: '',
      show: true
    },
    {
      name: 'pencil',
      sub: null,
      cursor: this.blob_image_url + 'DrawingTool/cursor/pencil.png',
      left: '0',
      top: '11.99',
      class: '',
      bg_class: '',
      show: true
    },
    {
      name: 'highlighter',
      sub: null,
      cursor: this.blob_image_url + 'DrawingTool/cursor/highlighter.png',
      left: '0',
      top: '11.99',
      class: '',
      bg_class: '',
      show: true
    },
    {
      name: 'text',
      sub: [
        {
          name: 'smallfont',
          sub: null,
          cursor: this.blob_image_url + 'DrawingTool/cursor/eraser.png',
          left: '0',
          top: '11.99',
          class: ''
        }, {
          name: 'mediumfont',
          sub: null,
          cursor: this.blob_image_url + 'DrawingTool/cursor/eraser.png',
          left: '0',
          top: '11.99',
          class: 'active'
        }, {
          name: 'bigfont',
          sub: null,
          cursor: this.blob_image_url + 'DrawingTool/cursor/eraser.png',
          left: '0',
          top: '11.99',
          class: ''
        }],
      cursor: this.blob_image_url + 'DrawingTool/cursor/text.png',
      left: '1',
      top: '1',
      class: '',
      submenFlag: false,
      bg_class: '',
      show: true
    },
    {
      name: 'shapes',
      cursor: this.blob_image_url + 'DrawingTool/cursor/line.png',
      left: '0',
      top: '11.99',
      sub: [
        {
          name: 'square',
          sub: null,
          cursor: this.blob_image_url + 'DrawingTool/cursor/square.png',
          left: '1',
          top: '1',
          class: ''
        }, {
          name: 'circle',
          sub: null,
          cursor: this.blob_image_url + 'DrawingTool/cursor/circle.png',
          left: '0',
          top: '0',
          class: ''
        }, {
          name: 'line',
          sub: null,
          cursor: this.blob_image_url + 'DrawingTool/cursor/line.png',
          left: '2',
          top: '2',
          class: ''
        }, {
          name: 'polygon',
          sub: null,
          cursor: this.blob_image_url + 'DrawingTool/cursor/polygon.png',
          left: '2',
          top: '2',
          class: ''
        }],
      class: '',
      submenFlag: false,
      bg_class: 'line',
      show: false
    },
    {
      name: 'eraser',
      cursor: this.blob_image_url + 'DrawingTool/cursor/eraser.png',
      left: '0',
      top: '11.99',
      sub: [
        {
          name: 'undo',
          sub: null,
          cursor: this.blob_image_url + 'DrawingTool/cursor/eraser.png',
          left: '0',
          top: '11.99',
          class: ''
        }, {
          name: 'redo',
          sub: null,
          cursor: this.blob_image_url + 'DrawingTool/cursor/eraser.png',
          left: '0',
          top: '11.99',
          class: ''
        }, {
          name: 'clear',
          sub: null,
          cursor: this.blob_image_url + 'DrawingTool/cursor/eraser.png',
          left: '0',
          top: '11.99',
          class: ''
        }],
      class: '',
      submenFlag: false,
      bg_class: '',
      show: true
    },
    {
      name: 'colorpicker',
      cursor: '',
      sub: [
        {
          name: 'red',
          value: '#EE5053',
          sub: null,
          cursor: '',
          class: ''
        }, {
          name: 'orange',
          value: '#FB9845',
          sub: null,
          cursor: '',
          class: ''
        }, {
          name: 'yellow',
          value: '#FDD04B',
          sub: null,
          cursor: '',
          class: ''
        }, {
          name: 'green',
          value: '#43C186',
          sub: null,
          cursor: '',
          class: ''
        }, {
          name: 'blue',
          value: '#32C2D5',
          sub: null,
          cursor: '',
          class: ''
        }, {
          name: 'magenta',
          value: '#AB64D5',
          sub: null,
          cursor: '',
          class: ''
        }, {
          name: 'purple',
          value: '#6455F4',
          sub: null,
          cursor: '',
          class: ''
        }, {
          name: 'black',
          value: '#000000',
          sub: null,
          cursor: '',
          class: ''
        }],
      class: '',
      submenFlag: false,
      bg_class: 'blue',
      show: true
    },
    {
      name: 'curtain',
      sub: null,
      cursor: this.blob_image_url + 'DrawingTool/cursor/curtain.png',
      left: '0',
      top: '11.99',
      class: '',
      bg_class: '',
      togglecurtain: false,
      show: false
    }];

  public shapeSelected = "line";
  public fontSelected = "small";
  public colorSelected = "black";
  public colorCodeSelected = "#000000";

  public canvas_cursor = "";
  public textbox_show = false;

  // public isSunmenuOpened = false;
  public create_text = 0;

  public canvas: any;
  public newleft = 0;

  public bigfontsize = 32.5;
  public mediumfontsize = 20.5;
  public smallfontsize = 10.5;
  public common_font_size = this.bigfontsize; //default big font size

  public olddata: any;


  public isRedoing = false;
  public h: any = [];

  public lineOn = false;
  public line: any;

  public origX;
  public origY;

  public popup_menu: any = {
    wp_confirmationOverlay: false,
    wp_confirmationWindow: false
  };

  public textbox_attr: any = {
    custom_top: 0,
    custom_left: 0,
    drawingToolText_fontsize: "",
    drawingToolText_height: "",
    drawingToolText_left: "",
    drawingToolText_top: "",
    x_ratio: 0,
    y_ratio: 0,
    flag_text_readonly: false,
    drawingToolTextFlag: false
  };


  public drawingToolContainer_attr: any = {
    last_top: 0,
    last_left: 0,
    last_top_px: "",
    last_left_px: "",
    last_x_ratio: 0.0,
    last_y_ratio: 0.0,
    startX: 0,
    startY: 0,
    Mouse_XPos: 0,
    Mouse_YPos: 0,
    x: 0,
    y: 0,
    draggedCount: 0
  };
  public current_menu_active = false;

  public sectionInfo: any = {
    current_section: '',
    current_book_name: '',
    pointerevents: 'pointer-ev-none',
    device_type: '',
    zindex: ''
  };

  public keyboardInfo: any = { open: false, readonly: false, class: "d-none" };

  public matteladan_section = "Mattelådan";
  public boken_section = "Boken";
  public berattelse_section = "BERÄTTELSE";

  constructor(private _ngZone: NgZone) {
    var thisme: any = this;
    this.marker = this.menudata[1];
    this.pencil = this.menudata[2];
    this.highlighter = this.menudata[3];
    this.text = this.menudata[4];
    this.shapes = this.menudata[5];
    this.eraser = this.menudata[6];
    this.colorpicker = this.menudata[7];
    this.curtainMenu = this.menudata[8];
    this.setDeviceType();
  }

  setDeviceType() {
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;

    var chrome_browser = userAgent.indexOf("chrome") > -1;
    var samsung_browser = userAgent.indexOf("samsung") > -1;
    var ipadmsg = "ipad";
    var msg = "no";
    if (isIOS) {
      this.sectionInfo.device_type = ipadmsg;
    }
    if (android_dev) {
      msg = "android";

      if (samsung_browser) {
        msg = msg + "_samsung";
      }
      else if (chrome_browser) {
        msg = msg + "_chrome";
      }
      this.sectionInfo.device_type = msg;
    }
  }

  keyboardToggle(status) {
    let classname = "d-none";
    if (status) {
      classname = "";
    }
    this.keyboardInfo.class = classname;
  }

  loadEvents() {
    var thisme: any = this;

    $(".btnPreviousExercise").click(function (e) {
      thisme.clear_screen();
    });

    $(".btnNextExercise").click(function (e) {
      thisme.clear_screen();
    });

    $("#btnclear").click(function (e) {
      thisme.clear_screen();
    });

  }

  ClickDrawShape(shape) {
    this.canvas.isDrawingMode = false;
    this.removeCanvasEvents();
    this.changeSelectableStatus(false);
    this.changeCanvasProperty(false, false);
    if (shape == "circle") {
      var circle: any = new Circle(this);
    }
    else if (shape == "square") {
      var squrect: any = new Rectangle(this);
    }
    else if (shape == "line") {
      this.line = new Line(this);
    }
    else {
      this.createPolygon();
    }
  }
  createPolygon() {
    // Draw Polygon
    var thisme: any = this;
    var is_creating, mouse_dragging, shape: any, mouseCoords;

    fabric.util.addListener(window, 'dblclick', function (evt) {
      is_creating = false;
      mouseCoords = {
        x: thisme.canvas.getPointer(evt.e, true).x,
        y: thisme.canvas.getPointer(evt.e, true).y
      };
    });

    this.canvas.on('mouse:down', function (evt) {
      mouse_dragging = true;
    });

    this.canvas.on('mouse:up', function (evt) {
      mouseCoords = {
        x: thisme.canvas.getPointer(evt.e, true).x,
        y: thisme.canvas.getPointer(evt.e, true).y
      };

      if (!is_creating) {
        is_creating = true;
        shape = new fabric.Polygon([{
          x: mouseCoords.x,
          y: mouseCoords.y
        }, {
          x: mouseCoords.x + 1,
          y: mouseCoords.y + 1
        }], {
          fill: "rgba(122, 190, 235, 0.5)",
          stroke: thisme.colorCodeSelected,
          perPixelTargetFind: true,
          top: mouseCoords.y,
          left: mouseCoords.x,
          strokeWidth: 2
        });
        thisme.canvas.add(shape);
      }
      else {
        shape.points.push({
          x: mouseCoords.x,
          y: mouseCoords.y
        });
        thisme.canvas.remove(shape);
        var obj = shape.toObject();
        delete obj.top;
        delete obj.left;

        shape = new fabric.Polygon(shape.points, obj);
        thisme.canvas.add(shape);

      }
      thisme.canvas.requestRenderAll(); // version 2 - renderAll() to requestRenderAll - august 14 2020
      thisme.canvas.setActiveObject(shape);

    });

  }
  setDrawShape(e, shape) {
    this.changeIconBackground(e);
    this.canvas.isDrawingMode = false;
    this.removeCanvasEvents();
    this.changeSelectableStatus(false);
    this.changeCanvasProperty(false, false);
    if (shape == "circle") {
      var circle: any = new Circle(this);
    }
    else if (shape == "square") {
      var squrect: any = new Rectangle(this);
    }
    else if (shape == "line") {
      this.line = new Line(this);
    }
    else {
      this.createPolygon();
    }
  }

  setDrawingColor(e, colortext) {
    this.clearcanvas(e);
    this.colorCodeSelected = document.getElementById(e.currentTarget.id).getAttribute("value");
    this.canvas.freeDrawingBrush.color = this.colorCodeSelected;
    this.changeIconBackground(e);
    localStorage.setItem('color_selected', colortext);
    this.colorchange(e);
  }

  changeCanvasProperty(selValue, drawingVal) {
    this.canvas.selection = selValue;
    this.canvas.isDrawingMode = drawingVal;
  }

  changeSelectableStatus(val) {
    this.canvas.forEachObject(function (obj) {
      obj.selectable = val;
    });
    this.canvas.requestRenderAll(); 
  }

  removeCanvasEvents() {
    this.canvas.off('mouse:down');
    this.canvas.off('mouse:move');
    this.canvas.off('mouse:up');
    this.canvas.off('object:moving');

     this.create_trashcan_event();

  }

  resetMenu() {

    this.drawingToolContainer_attr = {
      last_top: 0,
      last_left: 0,
      last_top_px: "",
      last_left_px: "",
      last_x_ratio: 0.0,
      last_y_ratio: 0.0,
      startX: 0,
      startY: 0,
      Mouse_XPos: 0,
      Mouse_YPos: 0,
      x: 0,
      y: 0,
      draggedCount: 0
    };

    this.textbox_attr = {
      custom_top: 0,
      custom_left: 0,
      drawingToolText_fontsize: "",
      drawingToolText_height: "",
      drawingToolText_left: "",
      drawingToolText_top: "",
      x_ratio: 0,
      y_ratio: 0,
      flag_text_readonly: false,
      drawingToolTextFlag: false
    };

    this.canvas.clear().requestRenderAll(); 
    this.newleft = 0;
    var menuChilds: any = this.menudata;
    for (var i = 0; i < menuChilds.length; i++) {
      menuChilds[i].class = '';
    }

    this.shapeSelected = "line";
    this.shapes.bg_class = this.shapeSelected;

    this.colorSelected = "yellow";
    this.colorCodeSelected = "#FDD04B";
    this.colorpicker.bg_class = this.colorSelected;

    this.colorpicker.submenFlag = false;
    this.shapes.submenFlag = false;
    this.eraser.submenFlag = false;
    this.text.submenFlag = false;

    //reset text-submenu
    for (var i = 0; i < this.text.sub.length; i++) {
      var activetext = "";
      this.text.sub[i].class = activetext;
    }
    //set default text-submenu
    if (this.sectionInfo.current_section == this.matteladan_section) {
      this.common_font_size = this.bigfontsize;
      this.text.sub[2].class = "active";
    }
    else if (this.sectionInfo.current_section == this.boken_section) {
      this.common_font_size = this.smallfontsize;
      this.text.sub[0].class = "active";
    }
    else {
      this.common_font_size = this.mediumfontsize;
      this.text.sub[1].class = "active";
    }

    this.changeDrawingToolStatus(false);

    this.canvas.freeDrawingBrush.color = this.colorCodeSelected;
    this.create_trascan();
    localStorage.removeItem("color_selected");
    this.keyboardToggle(false);
  }

  loadDrawingTool(current_section, current_book_name) {
    this.sectionInfo.current_section = current_section,
      this.sectionInfo.current_book_name = current_book_name;

    if (current_section == this.matteladan_section) {
      this.curtainMenu.show = true;
    }
    else {
      this.curtainMenu.show = false;
    }

    var thisme: any = this;

    this.canvas = new fabric.Canvas('wPaintCanvas');

    this.canvas.isDrawingMode = false;
    this.canvas.selection = false;
    this.canvas.counter = 0;

    this.resetMenu();

    setTimeout(function () {
      thisme.drawing_canvas_resizing();
    }, 10);
    this.loadTextsObjectEvent();

    this.canvas.on('object:added', function () {
      if (!this.isRedoing) {
        this.h = [];
      }
      this.isRedoing = false;
    });

    this.loadEvents();


  }

  loadTextsObjectEvent() {
    var thisme: any = this;
    var appObject: any = function () {
      return {
        __canvas: thisme.canvas,
        __tmpgroup: {},

        setTextParam: function (param, value) {

          var obj = this.__canvas.getActiveObject();
          if (obj) {
            if (param === 'color') {
              obj.setColor(value);
            }
            else {
              obj.set(param, value);
            }
            this.__canvas.requestRenderAll(); 
          }
        },
        setTextValue: function (value) {
          $("#my_drawing_tool_text_2").text($('#search_field').val());
          var flag_test = thisme.avoid_text_cross_canvas();
          if (flag_test) {
            $("#my_drawing_tool_text").text(value);
          }
        },
        addLayer: function () {

        }
      };
    };

    var app: any = appObject();

    $('#search_field').keyup(function () {
      app.setTextValue($(this).val());
    });

    $('#keyboard').click(function () {
      app.setTextValue($('#search_field').val());
    });
  }

  get_trash_can_position(actual_width, actual_height, actual_x, actual_y, actual_trashcan_w, actual_trashcan_h) {
    var canvas_area: any = document.getElementById("wPaint");
    var canvas_width = canvas_area.clientWidth;
    var canvas_height = canvas_area.clientHeight;



    var current_ratio_x = actual_x / actual_width;
    var current_x = canvas_width * current_ratio_x;

    var current_ratio_y = actual_y / actual_height;
    var current_y = canvas_height * current_ratio_y;

    var current_trashcan_w_ratio = actual_trashcan_w / actual_width;
    var current_trashcan_h_ratio = actual_trashcan_h / actual_height;

    var current_trashcan_w = canvas_width * current_trashcan_w_ratio;
    var current_trashcan_h = canvas_height * current_trashcan_h_ratio;
    this.olddata = { x: current_x, y: current_y, trashcan_w: current_trashcan_w, trashcan_h: current_trashcan_h };
    return this.olddata;
  }

  getIFontSize(font_size) {
    var canvas_area: any = document.getElementById("wPaint");
    if (canvas_area && canvas_area != "") {
      var canvas_width = canvas_area.clientWidth;
      var canvas_height = canvas_area.clientHeight;

      var common_width = 1298;
      var common_height = 525;

      var ratio_font = font_size / common_width;
      var common_font_size_temp = ratio_font * canvas_width;
      return common_font_size_temp;
    }
  }

  getCommonFontSize() {
    var canvas_area: any = document.getElementById("wPaint");
    if (canvas_area && canvas_area != "") {
      var canvas_width = canvas_area.clientWidth;
      var canvas_height = canvas_area.clientHeight;

      var common_width = 1298;
      var common_height = 525;

      var ratio_font = this.common_font_size / common_width;
      var common_font_size_temp = ratio_font * canvas_width;
      return common_font_size_temp;
    }
  }

  drawing_canvas_resizing() {

    var canvas_area: any = document.getElementById("wPaint");
    if (canvas_area && canvas_area != "") {
      var canvas_width = canvas_area.clientWidth;
      var canvas_height = canvas_area.clientHeight;

      $("#wPaintCanvas").attr("width", canvas_width + "px");
      $("#wPaintCanvas").attr("height", canvas_height + "px");

      if (this.canvas) {
        this.canvas.setDimensions({
          width: canvas_width,
          height: canvas_height
        });

        if (this.canvas && this.canvas != "") {
          if (this.canvas._objects.length > 0 && this.canvas._objects != "") {
            for (var j = 0; j < this.canvas._objects.length; j++) {
              if (this.canvas._objects[j].fontSize && this.canvas._objects[j].fontSize != "") {
                var font_size = this.canvas._objects[j].fontSizeTemp;
                var common_font_size_temp: any = this.getIFontSize(font_size);
                this.canvas._objects[j].fontSize = common_font_size_temp;
              }
            }
          }
        }
        this.canvas.requestRenderAll(); 
      }
    }


  }


  reset_textbox_after_resize() {
    //current resolution
    var canvas_width = $("#wPaint").innerWidth();
    var canvas_height = $("#wPaint").innerHeight();

    var textbox: any = document.getElementById("my_drawing_tool_text");
    if (textbox && textbox != "") {
      var elmnt2: any = document.getElementById("my_drawing_tool_text");
      var textbox_h = elmnt2.clientHeight;
      var textbox_w = elmnt2.clientWidth;

      var current_left = this.textbox_attr.custom_left; 

      var current_top = this.textbox_attr.custom_top; 

      var current_x_ratio = this.textbox_attr.x_ratio; 
      var current_y_ratio = this.textbox_attr.y_ratio; 

      if (current_left > 0 && current_top > 0) {
        var x = current_left;
        var y = current_top;
        if (current_left > 0) {
          x = current_x_ratio * canvas_width;
        }

        if (current_top > 0) {
          y = current_y_ratio * canvas_height;
        }
        var fixed_layer_y = (canvas_height - textbox_h);
        if (y > fixed_layer_y) {
          y = fixed_layer_y;
        }
        if (y < 1) {
          y = 1;
        }
        current_top = y;


        var fixed_layer_x = (canvas_width - (textbox_w));
        if (x > fixed_layer_x) {
          x = fixed_layer_x;
        }
        if (x < 0) {
          x = 0;
        }
        current_left = x;

        this.textbox_attr.custom_top = current_top;
        this.textbox_attr.custom_left = current_left;
        this.textbox_attr.drawingToolText_left = current_left + "px";
        this.textbox_attr.drawingToolText_top = current_top + "px";
      }

    }
  }

  reset_drawing_tool_after_resize() {
    //current resolution
    var canvas_width = $("#wPaint").innerWidth();
    var canvas_height = $("#wPaint").innerHeight();

    var drawing_tool: any = document.getElementById("mainmenu");
    if (drawing_tool && drawing_tool != "") {
      var drawing_tool_h = drawing_tool.clientHeight;
      var drawing_tool_w = drawing_tool.clientWidth;

      if (this.drawingToolContainer_attr.last_left > 0 && this.drawingToolContainer_attr.last_top > 0) {
        var x = this.drawingToolContainer_attr.last_left;
        var y = this.drawingToolContainer_attr.last_top;
        if (this.drawingToolContainer_attr.last_left > 0) {
          x = this.drawingToolContainer_attr.last_x_ratio * canvas_width;
        }

        if (this.drawingToolContainer_attr.last_top > 0) {
          y = this.drawingToolContainer_attr.last_y_ratio * canvas_height;
        }
        var fixed_layer_y = (canvas_height - drawing_tool_h - 10); 
        if (y > fixed_layer_y) {
          y = fixed_layer_y;
        }
        if (y < 1) {
          y = 1;
        }


        var fixed_layer_x = (canvas_width - (drawing_tool_w * 2.5));
        if (x > fixed_layer_x) {
          x = fixed_layer_x;
        }
        if (x < 0) {
          x = 0;
        }
        this.drawingToolContainer_attr.last_left = x;
        this.drawingToolContainer_attr.last_tops = y;

        this.drawingToolContainer_attr.last_left_px = x + "px";
        this.drawingToolContainer_attr.last_top_px = y + "px";
      }
    }

  }

  onmousemove: any;
  onmouseup: any;


  dragMenuElem(event, name) {
    
    if (name == "menuhandle") {

     
      event.preventDefault();
      this.drawingToolContainer_attr.Mouse_XPos = event.pageX;
      this.drawingToolContainer_attr.Mouse_YPos = event.pageY;
      this.drawingToolContainer_attr.startX = event.pageX - this.drawingToolContainer_attr.x;
      this.drawingToolContainer_attr.startY = event.pageY - this.drawingToolContainer_attr.y;

      var thisme: any = this;

      if (!this.onmousemove) {
        this.onmousemove = this.mousemove.bind(this);
      }
      if (!this.onmouseup) {
        this.onmouseup = this.mouseup.bind(this);
      }

      document.addEventListener("mousemove", this.onmousemove, false);
      document.addEventListener("mouseup", this.onmouseup, false);
    }
    
  }

  //smooth scroll for strorybook and pages
  smoothScrollIframePages(dragStatus) {
    let pageobject: any = document.getElementById("idIframe"); 

    if (!pageobject || pageobject == "") {
      pageobject = document.getElementById("jpedal"); 
    }

    if (pageobject && pageobject != "") {
      let object_value = pageobject.classList.value;
      if (dragStatus) {
        if (object_value.indexOf("nonpointerevents") == -1) {
          pageobject.classList.value = object_value + " nonpointerevents";
        }
      }
      else {
        let newStr = object_value.replace(" nonpointerevents", "");
        pageobject.classList.value = newStr;
      }
    }
  }

  mousemove(event) {

    if (this.drawingToolContainer_attr.Mouse_XPos !== event.pageX && this.drawingToolContainer_attr.Mouse_YPos !== event.pageY) {

      //smooth scroll start for strorybook and pages
      this.smoothScrollIframePages(true);

      var wpaint_canvas: any = document.getElementById("wPaint");
      var canvas_width = $("#wPaint").innerWidth();
      var canvas_height = $("#wPaint").innerHeight();


      var subtool: any = document.getElementById("mainmenu");
      var subtool_width = subtool.clientWidth;

      var drawing_tool: any = document.getElementById("mainmenu");
      var drawing_tool_h = drawing_tool.clientHeight;
      var drawing_tool_w = drawing_tool.clientWidth;

      var wpc_offsetLeft = wpaint_canvas.offsetLeft;
      var stwidth = subtool_width;      

      var x = event.pageX - wpc_offsetLeft - stwidth;
      var y = event.pageY - wpaint_canvas.offsetTop - (subtool_width / 2);


      var fixed_layer_y = (canvas_height - drawing_tool_h - 10); 
      if (y > fixed_layer_y) {
        y = fixed_layer_y;
      }
      if (y < 1) {
        y = 1;
      }


      var fixed_layer_x = (canvas_width - (drawing_tool_w * 2.5));
      if (x > fixed_layer_x) {
        x = fixed_layer_x;
      }
      if (x < 0) {
        x = 0;
      }

      this.drawingToolContainer_attr.last_left = x;
      this.drawingToolContainer_attr.last_top = y;

      this.drawingToolContainer_attr.last_left_px = x + "px";
      this.drawingToolContainer_attr.last_top_px = y + "px";
      this.drawingToolContainer_attr.last_x_ratio = x / canvas_width;
      this.drawingToolContainer_attr.last_y_ratio = y / canvas_height;


    }
  }

  mouseup(e) {
    //smooth scroll end for strorybook and pages
    this.smoothScrollIframePages(false);
    this.drawingToolContainer_attr.draggedCount = this.drawingToolContainer_attr.draggedCount + 0;
    document.removeEventListener("mousemove", this.onmousemove, false);
    document.removeEventListener("mouseup", this.onmouseup, false);
  }


  //--------------------------------draggable end---------------------------------------------------//

  setCursor(e) {
    if (this.current_menu_active) {
      var current_data: any = document.getElementById(e.currentTarget.id);
      var left = current_data.getAttribute("left");
      var top = current_data.getAttribute("top");
      var cursor = "";
      if (e.currentTarget.id === "shapes") {
        cursor = this.blob_image_url + "DrawingTool/cursor/" + this.shapeSelected + ".png";
      }
      else {
        var cursor_attr = current_data.getAttribute("cursor");
        cursor = cursor_attr;
      }
      this.canvas.freeDrawingCursor = "url(" + cursor + ") " + left + " " + top + ", auto";
      this.canvas.defaultCursor = "url(" + cursor + ") " + left + " " + top + ", auto";
    }
    else {
      this.canvas.freeDrawingCursor = "default";
      this.canvas.defaultCursor = "default";
    }
  }

  toggleCurtain(t_flag) {
    if (this.sectionInfo.current_section == this.matteladan_section) {
      var matService = window['matService'];
      if (matService && matService !== "") {
        matService.geoService.curtain_element_flag = t_flag;
        matService.geoService.toggleCurtain(matService);
      }
    }
  }

  markerClick(e) {
    this.toggleCurtain(false);

    this.removeMenuActiveTools(e);
    this.setCursor(e);
    this.removeCanvasEvents();
    this.canvas.isDrawingMode = false;
    this.changeCanvasProperty(true, false);
    this.changeSelectableStatus(true);
    this.bin_img.set('selectable', false);
    
    if (this.selectedObject && this.selectedObject != "") {
      this.selectedObject.hasBorders = false;
      this.selectedObject.hasControls = false;
    }

    this.canvas.requestRenderAll();
    this.create_trascan();
  }
  curtainClick(e) {
    this.setCursor(e);
    this.removeMenuActiveTools(e);
    if (this.sectionInfo.current_section == this.matteladan_section) {
      var matService = window['matService'];
      if (matService && matService !== "") {
        var t_flag = !matService.geoService.curtain_element_flag;
        this.toggleCurtain(t_flag);
      }
    }
  }
  pencilClick(e) {
    var thisme: any = this;
    this.toggleCurtain(false);
    this.removeMenuActiveTools(e);
    this.setCursor(e);
    this.removeCanvasEvents();
    this.canvas.isDrawingMode = true;

    this.canvas.freeDrawingBrush = new fabric.PencilBrush(this.canvas);
    this.canvas.freeDrawingBrush.color = this.colorCodeSelected;
    this.canvas.freeDrawingBrush.width = 3;
    this.canvas.on('path:created', function (opt) {
      opt.path.globalCompositeOperation = 'source-over';
      thisme.canvas.requestRenderAll(); 
    });

    //update for console error
    //active object on the click
    if (this.selectedObject && this.selectedObject != "") {
      this.selectedObject.hasBorders = false;
      this.selectedObject.hasControls = false;
    }
    this.canvas.requestRenderAll();
    
  }

  convertHex(hex, opacity) {
    hex = hex.replace('#', '');
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    let result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
    return result;
  }

  highlighterClick(e) {
    var thisme: any = this;
    this.toggleCurtain(false);
    this.removeMenuActiveTools(e);
    this.setCursor(e);
    this.removeCanvasEvents();
    this.canvas.isDrawingMode = true;
    this.canvas.freeDrawingBrush = new fabric.PencilBrush(this.canvas);
    this.canvas.freeDrawingBrush.color = this.convertHex(this.colorCodeSelected, 50); 
    this.canvas.freeDrawingBrush.width = 20;
    this.canvas.on('path:created', function (opt) {
      opt.path.globalCompositeOperation = 'multiply';
      thisme.canvas.requestRenderAll(); 
    });
   
    if (this.selectedObject && this.selectedObject != "") {
      this.selectedObject.hasBorders = false;
      this.selectedObject.hasControls = false;
    }
    this.canvas.requestRenderAll();
    
  }

  eraserClick(e) {
    var thisme: any = this;
    this.toggleCurtain(false);
    this.removeMenuActiveTools(e);
    this.setCursor(e);
    this.removeCanvasEvents();

    this.canvas.isDrawingMode = true;
    this.canvas.freeDrawingBrush.color = "#ffffff";
    this.canvas.freeDrawingBrush.width = 20;
    this.canvas.on('path:created', function (opt) {
      opt.path.globalCompositeOperation = 'destination-out';
      thisme.canvas.requestRenderAll(); 
    });
    //update for console error
    //active object on the click
    if (this.selectedObject && this.selectedObject != "") {
      this.selectedObject.hasBorders = false;
      this.selectedObject.hasControls = false;
    }
    this.canvas.requestRenderAll();
    
  }
  textClick(e) {
    var thisme: any = this;
    this.toggleCurtain(false);

    var search_field: any = document.getElementById("search_field");
    search_field.disabled = false;

    var current_service: any = window['current_service'];

    if (this.sectionInfo.current_section == this.matteladan_section) {
      var matService = window['matService'];
      if (matService && matService !== "") {
        matService.geoService.remove_all_active_highlighters(matService);
        matService.stage.update();
      }
    }
    else if (current_service == "ExerciseDisplayService") {
      var exerciseDisplayService = window['displayservice'];
      if (exerciseDisplayService && exerciseDisplayService !== "") {
        exerciseDisplayService.remove_all_active_highlighters(exerciseDisplayService);
        exerciseDisplayService.stage.update();
      }
    }
    else {
      var canvasService = window['canvasService'];
      if (canvasService && canvasService != "") 
      {
        if (canvasService.stage && canvasService.stage != "") {
          canvasService.geoService.remove_all_active_highlighters2(canvasService);
          canvasService.stage.update();
        }
      }
    }
    //update for console error
    //active object on the click
    if (this.selectedObject && this.selectedObject != "") {
      this.selectedObject.hasBorders = false;
      this.selectedObject.hasControls = false;
    }
    this.canvas.requestRenderAll();
    

    this.removeMenuActiveTools(e);
    this.setCursor(e);
    this.removeCanvasEvents();
    $('#search_field').val("");
    this.canvas.isDrawingMode = false;
    var tempclick2 = 0;
    this.canvas.on('mouse:down', function (options) {
      if (tempclick2 == 0) {
        tempclick2++;
        var search_field: any = document.getElementById("search_field");
        search_field.disabled = true;
        /*manual click create js textbox and  re-edit textbox */
        var status_textbox = false;
        if (thisme.sectionInfo.current_section == thisme.matteladan_section) {
          var matService: any = window['matService'];
          if (matService && matService !== "") {
            status_textbox = matService.testTextboxHit(matService, options);

            if (!status_textbox) {
              matService.geoService.remove_all_active_highlighters(matService);
              matService.stage.update();
              
              if (options.target === null) {
                thisme.addText(options.e, "", 0, 0, 0);
              }
              else {
                if (options.target.text && options.target.text != "") {
                  thisme.textbox_show = false;
                  thisme.set_text_canvas();
                  thisme.canvas.remove(options.target);
                  thisme.addText(e, options.target.text, options.target.left, options.target.top, options.target.fontSize);
                }
              }
              
            }
            else {
              thisme.keyboardToggle(true);
              var search_field: any = document.getElementById("search_field");
              search_field.disabled = false;
              thisme.textbox_show = false;
              thisme.set_text_canvas();
            }
          }
          else {
            thisme.callNormaltext(e, options);
          }
        }
        else {
          thisme.callNormaltext(e, options);
        }
      }
      setTimeout(function () { tempclick2 = 0; }, 10);
    });
  }
  undoClick(e) {
    if (this.canvas._objects.length > 0) {
      this.canvas.discardActiveObject();
      this.canvas.requestRenderAll(); 
      this.h.push(this.canvas._objects.pop());
      this.canvas.requestRenderAll(); 
    }
  }
  redoClick(e) {
    if (this.h.length > 0) {
      this.isRedoing = true;
      this.canvas.add(this.h.pop());
    }
  }

  shapesClick(e) {
    this.toggleCurtain(false);
    this.removeMenuActiveTools(e);
    this.setCursor(e);
    if (this.shapeSelected && this.shapeSelected != "") {
      this.ClickDrawShape(this.shapeSelected);
    }
    //update for console error
    //active object on the click
    if (this.selectedObject && this.selectedObject != "") {
      this.selectedObject.hasBorders = false;
      this.selectedObject.hasControls = false;
    }
    this.canvas.requestRenderAll();
    
  }
  colorpickerClick(e) {
    this.clearcanvas(e);
    this.colorchange(e);
  }

  clearClick(e) {
    this.sectionInfo.zindex = "WP_popupopen";
    this.popup_menu.wp_confirmationOverlay = true;
    this.popup_menu.wp_confirmationWindow = true;
  }

  wp_btnOkClick(e) {

    this.resetMenu();
    this.wp_btnCancelClick();
    
  }

  wp_btnCancelClick() {
    this.sectionInfo.zindex = "";
    this.popup_menu.wp_confirmationOverlay = false;
    this.popup_menu.wp_confirmationWindow = false;
  }

  clear_screen() {
    this.canvas.clear().requestRenderAll(); 
    this.newleft = 0;
    var thisme: any = this;
    setTimeout(function () {
      thisme.create_trascan();
      thisme.canvas.requestRenderAll(); 
    }, 500);
  }

  callNormaltext(e, options) {
    if (options.target === null) {
      this.addText(options.e, "", 0, 0, 0);
    }
    else {
      if (options.target.text && options.target.text != "") {
        this.textbox_show = false;
        this.set_text_canvas();
        this.canvas.remove(options.target);
        this.addText(e, options.target.text, options.target.left, options.target.top, options.target.fontSize);
      }
    }
  }

  set_text_canvas() {
    var thisme: any = this;
    var textbox1: any = document.getElementById("my_drawing_tool_text");
    if (textbox1 && textbox1 != "") {
      var text_final = textbox1.textContent;
      if (text_final && text_final != "") {
        var custom_top_text = 6.5;
        var custom_left_text = 1.5;
        var test_canvas_width = 1298;
        var test_canvas_height = 552;
        var text_x_ratio = custom_left_text / test_canvas_width;
        var text_y_ratio = custom_top_text / test_canvas_height;


        var elmnt = document.getElementById("wPaint");
        var c_width = elmnt.clientWidth;
        var c_height = elmnt.clientHeight;
        custom_top_text = c_height * text_y_ratio;
        custom_left_text = c_width * text_x_ratio;

        var common_font_size_temp = this.textbox_attr.drawingToolText_fontsize;

        var ypos = +(this.textbox_attr.custom_top) + custom_top_text;
        var xpos = +(this.textbox_attr.custom_left) + custom_left_text;

        var text = new fabric.Text(text_final,
          {
            top: ypos,
            left: xpos,
            fontFamily: 'Myriad Pro',
            fontSize: common_font_size_temp,
            fontSizeTemp: common_font_size_temp,
            fontWeight: 400,
            fill: this.colorCodeSelected,
            fontStyle: 'normal',
          });
        this.canvas.add(text);
      }
    }

    this.textbox_attr.drawingToolTextFlag = false;
    this.textbox_show = false;
  }

  avoid_text_cross_canvas() {
    var textbox: any = document.getElementById("my_drawing_tool_text_2");

    if (textbox && textbox != "") {
      var textbox_w = textbox.clientWidth;

      var elmnt: any = document.getElementById("wPaint");
      var width_screen = elmnt.clientWidth;

      var x = this.textbox_attr.custom_left;
      var test_x = (width_screen - textbox_w);

      if (x > test_x) {
        return false;
      }
      else {
        return true;
      }

    }

  }

  manualkeyboardevent(e) {
    if (e.key == "Enter") {
      e.preventDefault();
    }
    else if (e.key == "Backspace" || e.key == "Delete") {
    }
    else {

      var textbox1: any = document.getElementById("my_drawing_tool_text");
      var old_text = textbox1.textContent;

      var textbox2: any = document.getElementById("my_drawing_tool_text_2");
      textbox2.textContent = old_text + e.key + " ";

      var flag_test = this.avoid_text_cross_canvas();
      if (!flag_test) {
        e.preventDefault();
      }
    }

  }
  is_touch_enabled() {
    return ('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints > 0);
  }

  /*re-edit textbox*/
  addText(e, defaultext, leftX, topY, fontSize) {
    var thisme: any = this;
    if (this.create_text == 1) {
      this.keyboardToggle(true);
      this.create_text = 2;
    }

    var search_field: any = document.getElementById("search_field");
    search_field.value = "";

    var common_font_size_temp = this.getCommonFontSize();

    if (defaultext && defaultext != "") {
      common_font_size_temp = fontSize;
    }

    var textboxsize = common_font_size_temp + 7;
    if (!this.textbox_show) {

      var search_field: any = document.getElementById("search_field");
      search_field.disabled = false;

      //for touch event - native keyboard popup - restriction
      this.textbox_attr.flag_text_readonly = true;
      if (this.is_touch_enabled()) {
        this.textbox_attr.flag_text_readonly = false;
      }

      this.textbox_attr.drawingToolTextFlag = true;
      this.textbox_attr.drawingToolText_height = textboxsize + "px";
      this.textbox_attr.drawingToolText_fontsize = common_font_size_temp + "px";

      this.textbox_show = true;
      setTimeout(function () {
        thisme.loadTextData(e, defaultext, common_font_size_temp, leftX, topY);
      }, 100);


    }
    else {
      this.textbox_show = false;
      this.set_text_canvas();
    }

  }
  loadTextData(e, defaultext, common_font_size_temp, leftX, topY) {
    var search_field: any = document.getElementById("search_field");
    search_field.value = "";

    var textbox1: any = document.getElementById("my_drawing_tool_text");

    var xpos;
    var ypos;
    /* re-edit textbox*/
    if (defaultext && defaultext != "") {
      xpos = leftX - 1;
      ypos = topY - 6;
      textbox1.textContent = defaultext;
      search_field.value = defaultext;
    }
    else {
      xpos = this.canvas.getPointer(e, true).x;
      ypos = this.canvas.getPointer(e, true).y;
    }

    var elmnt: any = document.getElementById("wPaint");
    var width_screen = elmnt.clientWidth;
    var height_screen = elmnt.clientHeight;

    var elmnt2 = textbox1;
    var textbox_h = elmnt2.clientHeight;
    var textbox_w = elmnt2.clientWidth;

    var test_y = (height_screen - textbox_h);
    var y = ypos;
    var x = xpos;

    if (y > test_y) {
      y = test_y;
    }

    var test_x = (width_screen - textbox_w);

    if (x > test_x) {
      x = test_x - 5;
    }

    if (x < 0) {
      x = 0;
    }

    if (y < 0) {
      y = 0;
    }


    //resizing ratio - alternative for vw
    var x_ratio = x / width_screen;
    var y_ratio = y / height_screen;

    this.textbox_attr.custom_top = y;
    this.textbox_attr.custom_left = x;

    this.textbox_attr.y_ratio = y_ratio;
    this.textbox_attr.x_ratio = x_ratio;


    this.textbox_attr.drawingToolText_fontsize = common_font_size_temp;


    textbox1.style.left = x + "px";
    textbox1.style.top = y + "px";


    setTimeout(function () {
      textbox1.focus();
    }, 500);
  }

  colorchange(e) {
    
    if (this.highlighter.class == "active") {
      this.canvas.freeDrawingBrush.color = this.convertHex(this.colorCodeSelected, 50);
      
    }

    if (this.eraser.class == "active") {
      this.canvas.freeDrawingBrush.color = "#ffffff";
    }


  }

  clearcanvas(e) {
    if (this.pencil.class == "active"
      || this.highlighter.class == "active"
      || this.marker.class == "active"
      || this.text.class == "active"
    ) {
      this.changeDrawingToolStatus(true);
    }
    else {
    }

    this.colorpicker.bg_class = this.colorSelected;
    this.colorpicker.submenFlag = !this.colorpicker.submenFlag;
    this.shapes.submenFlag = false;
    this.eraser.submenFlag = false;
    this.text.submenFlag = false;

    this.keyboardToggle(false);
  }

  changeIconBackground(e) {
    var current_title = document.getElementById(e.currentTarget.id).getAttribute("title");
    var imageUrl = "";
    if (current_title === "square" || current_title === "circle" || current_title === "line" || current_title === "polygon") {
      this.shapeSelected = current_title;
      this.shapes.bg_class = this.shapeSelected;
      this.shapes.submenFlag = false;
    }
    else if (current_title === "smallfont"
      || current_title === "mediumfont"
      || current_title === "bigfont") {
      this.text.submenFlag = false;
    }
    else if (current_title === "red" || current_title === "orange" || current_title === "yellow" || current_title === "green" || current_title === "blue" || current_title === "magenta" || current_title === "purple" || current_title === "black") {
      this.colorSelected = current_title;
      this.colorpicker.bg_class = this.colorSelected;
      this.colorpicker.submenFlag = false;
    }
  }

  loopBegreepPoniters(active) {
    var element: any = document.getElementsByClassName("begrepp-canvas");
    for (var i = 0; i < element.length; i++) {
      var ielement: any = element[i];
      ielement.classList.remove("pointer-ev-auto");
      ielement.classList.remove("pointer-ev-none");
      if (active) {
        ielement.classList.add("pointer-ev-none");
      }
      else {
        ielement.classList.add("pointer-ev-auto");
      }
    }
  }

  changeDrawingToolStatus(active) {
    this.loopBegreepPoniters(active);
    if (active) {
      this.sectionInfo.pointerevents = 'pointer-ev-auto';
    }
    else {
      this.sectionInfo.pointerevents = 'pointer-ev-none';
    }
  }

  deleteObjects() {
    var thisme: any = this;
    var activeObject: any = this.canvas.getActiveObject();
    if (activeObject._objects && activeObject._objects !== "") {
      var objectsInGroup: any = activeObject._objects;
      this.canvas._discardActiveObject();
      objectsInGroup.forEach(function (object) {
        thisme.canvas.remove(object);
      });
    }
    else {
      this.canvas.remove(activeObject);
    }
  }

  HandleElement(obj) {
    this.selectedObject = obj.target;
  }

  create_trashcan_event() {
    var thisme: any = this;

    this.canvas.on('selection:updated', function (evn) {
      thisme.HandleElement(evn);
    });

    this.canvas.on('selection:created', function (evn) {
      thisme.HandleElement(evn);
    });

    this.canvas.on('selection:cleared', function (evn) {
      thisme.selectedObject = null;
      thisme.bin_img.set({
        visible: false
      });
      thisme.dragging_flag = false;
    });


    this.canvas.on('mouse:up', function (evn) {
      if (thisme.trash_can_visible) {
        thisme.bin_img.set({
          visible: false
        });
        if (thisme.selectedObject) {
          if (thisme.dragging_flag) {
            var x = evn.e.offsetX;
            var y = evn.e.offsetY;
            if (x > thisme.bin_img.left && x < (thisme.bin_img.left + thisme.bin_img.width) &&
              y > thisme.bin_img.top && y < (thisme.bin_img.top + thisme.bin_img.height)) {
              thisme.deleteObjects();
              thisme.selectedObject = null;
            }
          }
          else {
            //updated console error
            thisme.selectedObject.hasBorders = true;
            thisme.selectedObject.hasControls = true;
          }
          thisme.dragging_flag = false;
        }
      }
    });

    this.canvas.on('mouse:down', function (evn) {
      if (thisme.trash_can_visible) {
        if (thisme.selectedObject) {

          thisme.bin_img.set({
            visible: true
          });
          thisme.dragging_flag = true;

          //active object on the click
          thisme.selectedObject.hasBorders = true;
          thisme.selectedObject.hasControls = true;
          thisme.canvas.requestRenderAll();
        }
      }
    });


    this.canvas.on('mouse:move', function (evn) {
      if (thisme.trash_can_visible) {
        if (thisme.selectedObject) {

          var x = evn.e.offsetX;
          var y = evn.e.offsetY;
          if (x > thisme.bin_img.left && x < (thisme.bin_img.left + thisme.bin_img.width) &&
            y > thisme.bin_img.top && y < (thisme.bin_img.top + thisme.bin_img.height)) {
            thisme.bin_img.set('opacity', 0.4);
          }
          else {
            thisme.bin_img.set('opacity', 1);
          }

        }
      }
    });
    this.bin_img.set('selectable', false);

  }

  create_trascan() {
    var elmnt: any = document.getElementById("wPaint");
    var width_screen = elmnt.clientWidth;
    var height_screen = elmnt.clientHeight;

    var actual_trashcan_w = 100;
    var actual_trashcan_h = 100;

    var actual_x = 1160; 
    var actual_y = 420;

    //resolution check
    var actual_width = 1298;
    var actual_height = 552;

    var position_x = 0;
    var position_y = 0;
    var position_w = 0;
    var position_h = 0;


    var canvas_area: any = document.getElementById("wPaint");
    var temp = 0;
    if (canvas_area && canvas_area != "") {
      var data = this.get_trash_can_position(actual_width, actual_height, actual_x, actual_y, actual_trashcan_w, actual_trashcan_h);
      position_x = data.x;
      position_y = data.y;
      position_w = data.trashcan_w;
      position_h = data.trashcan_w;
      temp = 1;
    }
    else if (this.olddata && this.olddata != "" && this.olddata.length > 0) {
      temp = 2;
      position_x = this.olddata.x;
      position_y = this.olddata.y;
      position_w = this.olddata.trashcan_w;
      position_h = this.olddata.trashcan_w;
    }
    var thisme: any = this;
    if (temp != 0) {
      fabric.Image.fromURL(this.blob_image_url + 'DrawingTool/images/trashcan.png', function (img) {
        img.set({
          left: position_x,
          top: position_y,
          selectable: false,
          visible: false
        });
        img.scaleToHeight(position_h);
        img.scaleToWidth(position_w);
        thisme.bin_img = img;
        thisme.canvas.add(img);
      });
    }
  }


  removeMenuActiveTools(e) {

    this.set_text_canvas();
    this.textbox_show = false;
    this.trash_can_visible = false;

    /* menu set active*/
    var menuChilds: any = this.menudata;
    var current_title = document.getElementById(e.currentTarget.id).getAttribute("title");
    this.current_menu_active = false;
    for (var i = 0; i < menuChilds.length; i++) {
      menuChilds[i].submenFlag = false;
      if (menuChilds[i].name === current_title) {
        //toggle Class
        menuChilds[i].class = (menuChilds[i].class === 'active') ? '' : 'active';
        this.current_menu_active = (menuChilds[i].class === 'active') ? true : false;
        menuChilds[i].submenFlag = this.current_menu_active;
      }
      else {
        if (current_title !== "colorpicker") {
          menuChilds[i].class = '';
        }
      }
    }
    /* menu set active*/

    this.shapes.bg_class = this.shapeSelected;
    this.colorpicker.bg_class = this.colorSelected;

    if (current_title === "marker"
      || current_title === "pencil"
      || current_title === "highlighter"
      || current_title === "text"
      || current_title === "shapes"
      || current_title === "eraser"
      || current_title === "marker"    ) {
      var keyboard_hide = true;
      this.changeDrawingToolStatus(this.current_menu_active);
      if (this.current_menu_active && current_title == "marker") {
        
        this.trash_can_visible = true;
      }
      else (current_title === "text")
      {
        if (this.current_menu_active) {
          this.create_text = 1;
        }
        else {
          
        }
      }

      if (keyboard_hide) {
        this.keyboardToggle(false);
      }
    }
    else {
      this.changeDrawingToolStatus(false);
    }
  }

  //avoiding settimout inside event currrent_target missing
  cloneEvent(e) {
    let clone = new ClonedEvent();
    for (let p in e) {
      let d = Object.getOwnPropertyDescriptor(e, p);
      if (d && (!d.writable || !d.configurable || !d.enumerable || d.get || d.set)) {
        Object.defineProperty(clone, p, d);
      }
      else {
        clone[p] = e[p];
      }
    }
    Object.setPrototypeOf(clone, e);
    return clone;
  }

  clickMenu(e, drawingtoolService, menuname) {
    var thisme: any = this;
    if (menuname == "marker") {
      this.markerClick(e);
    }
    else if (menuname == "pencil") {
      this.pencilClick(e);
    }
    else if (menuname == "curtain") {
      this.curtainClick(e);
    }
    else if (menuname == "highlighter") {
      this.highlighterClick(e);
    }
    else if (menuname == "eraser") {
      this.eraserClick(e);
    }
    else if (menuname == "text") {
      this.textClick(e);
    }
    else if (menuname == "shapes") {
      this.shapesClick(e);
    }
    else if (menuname == "colorpicker") {
      this.colorpickerClick(e);
    }

  }
  clickColorMenu(e, drawingtoolService, menuname) {
    this.setDrawingColor(e, menuname);
  }
  clickEraserMenu(e, drawingtoolService, menuname) {
    if (menuname == "undo") {
      this.undoClick(e);
    }
    else if (menuname == "redo") {
      this.redoClick(e);
    }
    else if (menuname == "clear") {
      this.clearClick(e);
    }
  }

  clickShapesMenu(e, drawingtoolService, menuname) {
    this.setCursor(e);
    if (menuname == "square") {
      this.setDrawShape(e, 'square');
    }
    else if (menuname == "circle") {
      this.setDrawShape(e, 'circle');
    }
    else if (menuname == "line") {
      this.setDrawShape(e, 'line');
    }
    else if (menuname == "polygon") {
      this.setDrawShape(e, 'polygon');
    }
  }
  clickTextMenu(e, drawingtoolService, menuname) {
    var ctext = e.currentTarget.id;

    for (var i = 0; i < this.text.sub.length; i++) {
      var activetext = "";
      if (ctext == this.text.sub[i]['name']) {
        activetext = "active";
      }
      this.text.sub[i].class = activetext;
    }

    this.common_font_size = this.bigfontsize;
    if (ctext == "smallfont") {
      this.common_font_size = this.smallfontsize;
    }
    else if (ctext == "mediumfont") {
      this.common_font_size = this.mediumfontsize;
    }

    this.changeIconBackground(e);
  }

  leftclick(tabname, hide_right_arrow) {
    var box_wrapper_id = "boxwrapper";
    var slide_div = "menubox";
    if (tabname == "Siffror / Symboler") {
      box_wrapper_id = "boxwrapper1";
      slide_div = "Siffror";
      tabname = "Siffror";
    }
    else if (tabname == "Tiobasmaterial_new") {
      box_wrapper_id = "boxwrapper2";
      slide_div = "Tiobasmaterial_new";
    }

    if (hide_right_arrow == true) {
      $("#right-arrow-" + tabname).addClass("arrow-disabled");
    }
    else {
      $("#right-arrow-" + tabname).removeClass("arrow-disabled");
    }
    var boxwrapper_width = $("#" + box_wrapper_id).css("width");
    boxwrapper_width = boxwrapper_width.replace("px", "");
    boxwrapper_width = +boxwrapper_width;

    var marginleft = $('#' + slide_div).css("margin-left");
    marginleft = marginleft.replace("px", "");
    marginleft = +(marginleft);
    marginleft = marginleft + (boxwrapper_width / 2);

    var arrow_width = $("#left-arrowcontainer").css("width");
    arrow_width = arrow_width.replace("px", "");
    arrow_width = +arrow_width;

    var default_margin = arrow_width;

    if (marginleft > default_margin) {
      marginleft = default_margin;
    }
    if (marginleft == default_margin) {
      $("#left-arrow-" + tabname).addClass("arrow-disabled");
    }
    $("#" + slide_div).animate({
      marginLeft: marginleft + 'px'
    }, 500);
  }

  rightclick(tabname, hide_right_arrow) {
    if (hide_right_arrow == false) {
      var box_wrapper_id = "boxwrapper";
      var slide_div = "menubox";
      if (tabname == "Siffror / Symboler") {
        box_wrapper_id = "boxwrapper1";
        slide_div = "Siffror";
        tabname = "Siffror";
      }
      else if (tabname == "Tiobasmaterial_new") {
        box_wrapper_id = "boxwrapper2";
        slide_div = "Tiobasmaterial_new";
      }


      $("#left-arrow-" + tabname).removeClass("arrow-disabled");
      var marginleft = $('#' + slide_div).css("margin-left");
      var width = $('#' + slide_div).css("width");
      width = width.replace("px", "");
      width = +width;

      var arrow_width = $("#left-arrowcontainer").css("width");
      arrow_width = arrow_width.replace("px", "");
      arrow_width = +arrow_width;

      var boxwrapper_width = $("#" + box_wrapper_id).css("width");
      boxwrapper_width = boxwrapper_width.replace("px", "");
      boxwrapper_width = +boxwrapper_width;

      marginleft = marginleft.replace("px", "");
      marginleft = marginleft.replace("vw", "");
      marginleft = +(marginleft);
      marginleft = marginleft - (boxwrapper_width / 2);


      if (marginleft < (boxwrapper_width - width - arrow_width)) {
        $("#right-arrow-" + tabname).addClass("arrow-disabled");
        marginleft = boxwrapper_width - width - arrow_width;
      }

      $("#" + slide_div).animate({
        marginLeft: marginleft + 'px'
      }, 500);

    }

  }

  scrolllastmenus() {
    setTimeout(function () {
      $("#left-arrow").removeClass("arrow-disabled");
      $("#right-arrow").removeClass("arrow-disabled");
      var arrow_width = $("#left-arrowcontainer").css("width");
      arrow_width = arrow_width.replace("px", "");
      arrow_width = +arrow_width;

      var boxwrapper_width = $("#boxwrapper").css("width");
      boxwrapper_width = boxwrapper_width.replace("px", "");
      boxwrapper_width = +boxwrapper_width;

      var width = $('#menubox').css("width");
      width = width.replace("px", "");
      width = +width;

      var marginleft = boxwrapper_width - width - arrow_width;
      $("#menubox").animate({
        marginLeft: marginleft + 'px'
      }, 500);
    }, 100);
  }

  loadJS() {

  }

  loadCSS() {
    var thisme: any = this;
    $(".keyboardStyle").remove();
    this.keyboardToggle(false);

    this.wp_btnCancelClick();

    document.addEventListener("touchstart", function () {
      thisme.keyboardInfo.readonly = true;
    }, true);

  }
}


class ClonedEvent {
  constructor() {
  }
}

class Line {
  canvas: any;
  className: string;
  isDrawing: boolean;
  thisme: any;

  constructor(thisme) {
    this.thisme = thisme;
    this.canvas = thisme.canvas;
    this.className = 'line';
    this.isDrawing = false;
    this.bindEvents();
  }

  bindEvents() {
    var inst = this;
    inst.canvas.on('mouse:down', function (o) {
      inst.onMouseDown(o);
    });
    inst.canvas.on('mouse:move', function (o) {
      inst.onMouseMove(o);
    });
    inst.canvas.on('mouse:up', function (o) {
      inst.onMouseUp(o);
    });
    inst.canvas.on('object:moving', function (o) {
      inst.disable();
    });
  }

  onMouseUp(o) {
    var inst = this;
    if (inst.isEnable()) {
      inst.disable();
    }
  }

  onMouseMove(o) {
    var inst = this;
    if (!inst.isEnable()) {
      return;
    }

    var pointer = inst.canvas.getPointer(o.e);
    var activeObj = inst.canvas.getActiveObject();

    activeObj.set({
      x2: pointer.x,
      y2: pointer.y
    });
    activeObj.setCoords();
    inst.canvas.requestRenderAll(); 
  }

  onMouseDown(o) {
    var inst = this;
    inst.enable();

    var pointer = inst.canvas.getPointer(o.e);
    this.thisme.origX = pointer.x;
    this.thisme.origY = pointer.y;

    var points = [pointer.x, pointer.y, pointer.x, pointer.y];
    var line = new fabric.Line(points, {
      strokeWidth: 2,
      stroke: this.thisme.colorCodeSelected,
      fill: this.thisme.colorCodeSelected,
      originX: 'center',
      originY: 'center',
      selectable: false,
      hasBorders: false,
      hasControls: false
    });
    inst.canvas.add(line).setActiveObject(line);
  }

  isEnable() {
    return this.isDrawing;
  }

  enable() {
    this.isDrawing = true;
  }

  disable() {
    this.isDrawing = false;
  }
}

class Circle {
  canvas: any;
  className: string;
  isDrawing: boolean;
  thisme: any;

  constructor(thisme) {
    this.thisme = thisme;
    this.canvas = thisme.canvas;
    this.className = 'Circle';
    this.isDrawing = false;
    this.bindEvents();
  }

  bindEvents() {
    var inst = this;
    inst.canvas.on('mouse:down', function (o) {
      inst.onMouseDown(o);
    });
    inst.canvas.on('mouse:move', function (o) {
      inst.onMouseMove(o);
    });
    inst.canvas.on('mouse:up', function (o) {
      inst.onMouseUp(o);
    });
    inst.canvas.on('object:moving', function (o) {
      inst.disable();
    });
  }

  onMouseUp(o) {
    var inst = this;
    inst.disable();
  }

  onMouseMove(o) {
    var inst = this;
    if (!inst.isEnable()) {
      return;
    }

    var pointer = inst.canvas.getPointer(o.e);
    var activeObj = inst.canvas.getActiveObject();

    activeObj.stroke = this.thisme.colorCodeSelected,
      activeObj.strokeWidth = 2;
    activeObj.fill = 'transparent';

    if (this.thisme.origX > pointer.x) {
      activeObj.set({
        left: Math.abs(pointer.x)
      });
    }

    if (this.thisme.origY > pointer.y) {
      activeObj.set({
        top: Math.abs(pointer.y)
      });
    }

    activeObj.set({
      rx: Math.abs(this.thisme.origX - pointer.x) / 2
    });
    activeObj.set({
      ry: Math.abs(this.thisme.origY - pointer.y) / 2
    });
    activeObj.setCoords();
    inst.canvas.requestRenderAll(); 
  }

  onMouseDown(o) {
    var inst = this;
    inst.enable();

    var pointer = inst.canvas.getPointer(o.e);
    this.thisme.origX = pointer.x;
    this.thisme.origY = pointer.y;

    var ellipse = new fabric.Ellipse({
      top: this.thisme.origY,
      left: this.thisme.origX,
      rx: 0,
      ry: 0,
      selectable: false,
      hasBorders: false,
      hasControls: false
    });

    inst.canvas.add(ellipse).setActiveObject(ellipse);
  }

  isEnable() {
    return this.isDrawing;
  }

  enable() {
    this.isDrawing = true;
  }

  disable() {
    this.isDrawing = false;
  }

}

class Rectangle {
  canvas: any;
  className: string;
  isDrawing: boolean;
  thisme: any;
  constructor(thisme) {
    this.thisme = thisme;
    this.canvas = thisme.canvas;
    this.className = 'Rectangle';
    this.isDrawing = false;
    this.bindEvents();
  }

  bindEvents() {
    var inst = this;
    inst.canvas.on('mouse:down', function (o) {
      inst.onMouseDown(o);
    });
    inst.canvas.on('mouse:move', function (o) {
      inst.onMouseMove(o);
    });
    inst.canvas.on('mouse:up', function (o) {
      inst.onMouseUp(o);
    });
    inst.canvas.on('object:moving', function (o) {
      inst.disable();
    });
  }

  onMouseUp(o) {
    var inst = this;
    inst.disable();
  }

  onMouseMove(o) {
    var inst = this;

    if (!inst.isEnable()) {
      return;
    }
    var pointer = inst.canvas.getPointer(o.e);
    var activeObj = inst.canvas.getActiveObject();

    activeObj.stroke = this.thisme.colorCodeSelected,
      activeObj.strokeWidth = 2;
    activeObj.fill = 'transparent';

    if (this.thisme.origX > pointer.x) {
      activeObj.set({
        left: Math.abs(pointer.x)
      });
    }
    if (this.thisme.origY > pointer.y) {
      activeObj.set({
        top: Math.abs(pointer.y)
      });
    }

    activeObj.set({
      width: Math.abs(this.thisme.origX - pointer.x)
    });
    activeObj.set({
      height: Math.abs(this.thisme.origY - pointer.y)
    });

    activeObj.setCoords();
    inst.canvas.requestRenderAll(); 

  }

  onMouseDown(o) {
    var inst = this;
    inst.enable();

    var pointer = inst.canvas.getPointer(o.e);
    this.thisme.origX = pointer.x;
    this.thisme.origY = pointer.y;

    var rect = new fabric.Rect({
      left: this.thisme.origX,
      top: this.thisme.origY,
      originX: 'left',
      originY: 'top',
      width: pointer.x - this.thisme.origX,
      height: pointer.y - this.thisme.origY,
      selectable: false,
      hasBorders: false,
      hasControls: false
    });
    inst.canvas.add(rect).setActiveObject(rect);
  }

  isEnable() {
    return this.isDrawing;
  }

  enable() {
    this.isDrawing = true;
  }

  disable() {
    this.isDrawing = false;
  }
}
